import {GenericService} from '@/shared/xhttp';
import {DocumentAchat} from "@/models/DocumentAchat";

export class DocumentAchatService extends GenericService<DocumentAchat> {
}